import styled from 'styled-components';
import getIn from 'immutable-less/transmute/getIn';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PartialSuccessMessage from 'automation-ui-log-events/components/execution-results/PartialSuccessMessage';
import { formatExecutionResults } from 'automation-ui-log-events/components/execution-results/utils/formatExecutionResults';
import ExecutionEventTable from 'automation-ui-log-events/components/execution-results/components/ExecutionEventTable';
import ExecutionResultsLoading from 'automation-ui-log-events/components/execution-results/components/ExecutionResultsLoading';
import ExecutionResultsError from 'automation-ui-log-events/components/execution-results/components/ExecutionResultsError';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TitleContainer = styled.div.withConfig({
  displayName: "FailedExecutionResults__TitleContainer",
  componentId: "sc-1a8p41v-0"
})(["padding-top:10px;padding-bottom:10px;"]);
const FailedExecutionResults = ({
  actionType,
  error,
  executionResults,
  flowObjectTypeId,
  loading,
  logEvent
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(ExecutionResultsLoading, {});
  }
  if (error) {
    return /*#__PURE__*/_jsx(ExecutionResultsError, {});
  }
  const hasFailureResults = executionResults.length > 0;
  const groupedFailureResults = formatExecutionResults(executionResults);
  return hasFailureResults ? /*#__PURE__*/_jsx(_Fragment, {
    children: Object.keys(groupedFailureResults).map(errorType => {
      const failedExecutionResult = getIn([errorType, 0], groupedFailureResults);
      const eventMessage = /*#__PURE__*/_jsx(PartialSuccessMessage, {
        executionResult: failedExecutionResult,
        flowObjectTypeId: flowObjectTypeId,
        logEvent: logEvent
      });
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(ExecutionEventTable, {
          titleContent: eventMessage,
          executionResults: groupedFailureResults[errorType],
          flowObjectTypeId: flowObjectTypeId,
          actionType: actionType
        })
      }, errorType);
    })
  }) : /*#__PURE__*/_jsx(TitleContainer, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-log-events.logEventExecutionResultsTable.allSuccess"
    })
  });
};
export default FailedExecutionResults;